var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "steam_home" } }, [
    _c("div", { staticClass: "home" }, [
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "box_btn", on: { click: _vm.toCaseList } }, [
          _vm._v("点击开箱"),
          _c("img", {
            attrs: {
              src: require("../resources/images/home/arrow.png"),
              alt: "",
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }